import { Package, PhoneCall, Truck } from 'lucide-react';

const F = "'Alan Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const BRAND_FEATURES = [
  { Icon: Package,   title: 'Gestion de stock',     sub: 'Suivi de votre inventaire en temps réel' },
  { Icon: PhoneCall, title: 'Confirmation client',  sub: 'Nos closers valident chaque commande' },
  { Icon: Truck,     title: 'Livraison express',    sub: 'Partout au Sénégal, suivi GPS inclus' },
];

// ─── Icônes sociales ───────────────────────────────────────────────────────────
export function GoogleIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}
export function AppleIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#000" style={{ flexShrink: 0 }}>
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
    </svg>
  );
}

// ─── Styles ────────────────────────────────────────────────────────────────────
function AuthStyles() {
  return (
    <style>{`
      @keyframes auth-spin   { to { transform: rotate(360deg); } }
      @keyframes auth-fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }

      .auth-shell { display:flex; min-height:100vh; min-height:100dvh; background:#fff; font-family:${F}; }

      /* ── Panneau marque (desktop) ── */
      .auth-brand {
        flex:0 0 46%; max-width:600px; position:relative; overflow:hidden;
        background:linear-gradient(165deg, #07162d 0%, #0d2347 55%, #112c52 100%);
        display:flex; flex-direction:column; justify-content:space-between; padding:52px 52px 40px;
      }
      .auth-brand::before {
        content:''; position:absolute; inset:0;
        background-image: radial-gradient(rgba(255,255,255,0.045) 1px, transparent 1px);
        background-size:24px 24px; pointer-events:none;
      }
      .auth-brand::after {
        content:''; position:absolute; top:-140px; right:-140px; width:420px; height:420px;
        border-radius:50%; background:radial-gradient(circle, rgba(42,102,184,0.28) 0%, transparent 70%); pointer-events:none;
      }
      .brand-logo { position:relative; z-index:1; height:46px; object-fit:contain; align-self:flex-start; }
      .brand-body { position:relative; z-index:1; }
      .brand-eyebrow { font-size:12px; font-weight:700; color:#93c5fd; text-transform:uppercase; letter-spacing:2.5px; margin-bottom:18px; }
      .brand-head { font-size:clamp(28px,3vw,36px); font-weight:800; color:#fff; line-height:1.16; letter-spacing:-0.8px; margin:0 0 16px; }
      .brand-head .accent { color:#c53a2d; }
      .brand-sub { font-size:15px; color:rgba(255,255,255,0.55); line-height:1.65; margin:0 0 40px; max-width:400px; }
      .brand-features { display:flex; flex-direction:column; gap:20px; }
      .brand-feat { display:flex; align-items:flex-start; gap:14px; }
      .brand-feat-ic { width:44px; height:44px; border-radius:12px; background:rgba(255,255,255,0.07); border:1px solid rgba(255,255,255,0.1); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
      .brand-feat-t { font-size:14.5px; font-weight:700; color:#fff; margin:0 0 2px; }
      .brand-feat-s { font-size:12.5px; color:rgba(255,255,255,0.45); margin:0; line-height:1.45; }
      .brand-foot { position:relative; z-index:1; display:flex; gap:28px; align-items:center; padding-top:26px; border-top:1px solid rgba(255,255,255,0.08); }
      .brand-stat-v { font-size:16px; font-weight:800; color:#fff; line-height:1; }
      .brand-stat-l { font-size:11px; color:rgba(255,255,255,0.4); margin-top:4px; }

      /* ── Côté formulaire ── */
      .auth-main { flex:1; display:flex; flex-direction:column; min-width:0; }
      .auth-form-wrap { flex:1; display:flex; align-items:center; justify-content:center; padding:48px 24px; }
      .auth-form-inner { width:100%; max-width:392px; animation:auth-fadeUp .42s ease; }

      /* Icône d'app (mobile) */
      .auth-mark { display:none; }

      .auth-title { font-size:27px; font-weight:800; color:#173b78; margin:0 0 7px; letter-spacing:-0.5px; }
      .auth-subtitle { font-size:14px; color:#64748b; margin:0 0 26px; line-height:1.5; }

      .auth-label { display:block; font-size:11px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:0.8px; margin-bottom:8px; }
      .auth-field { position:relative; margin-bottom:14px; }

      .auth-input {
        width:100%; padding:15px 15px; background:#f4f6fa; border:1.5px solid #e8ecf2; border-radius:13px;
        font-size:15px; color:#0f172a; font-family:${F}; outline:none; box-sizing:border-box;
        transition:border-color .15s, background .15s, box-shadow .15s;
      }
      .auth-input::placeholder { color:#9ca3af; }
      .auth-input:focus { border-color:#173b78; background:#fff; box-shadow:0 0 0 4px rgba(23,59,120,0.1); }
      .auth-input.err { border-color:#dc2626; background:#fff7f7; }
      .auth-input.with-icon { padding-left:46px; }
      .auth-input.with-eye  { padding-right:46px; }

      .auth-fieldicon { position:absolute; left:15px; top:50%; transform:translateY(-50%); color:#94a3b8; pointer-events:none; display:flex; }
      .auth-eye { position:absolute; right:14px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:#94a3b8; display:flex; padding:3px; transition:color .15s; }
      .auth-eye:hover { color:#475569; }

      .auth-forgot { display:block; width:100%; text-align:center; margin:6px 0 16px; font-size:13px; color:#173b78; font-weight:600; background:none; border:none; cursor:pointer; font-family:${F}; transition:color .15s; }
      .auth-forgot:hover { color:#2a66b8; }

      .auth-error { display:flex; align-items:center; gap:8px; margin-bottom:14px; padding:11px 13px; background:#fef2f2; border:1px solid #fecaca; border-radius:11px; font-size:13px; color:#dc2626; font-weight:500; }

      .auth-note { background:#f0fdf4; border:1px solid #bbf7d0; border-radius:12px; padding:13px 15px; margin-bottom:22px; }
      .auth-note-title { font-size:13px; color:#15803d; font-weight:600; }
      .auth-note-sub { font-size:11px; color:#94a3b8; margin-top:4px; }

      .auth-btn {
        width:100%; padding:15px; border:none; border-radius:13px; font-size:14.5px; font-weight:700; letter-spacing:0.3px;
        font-family:${F}; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:8px;
        transition:opacity .18s, transform .18s, box-shadow .18s;
      }
      .auth-btn:not(:disabled):hover { opacity:0.93; transform:translateY(-1px); box-shadow:0 10px 28px rgba(23,59,120,0.32); }
      .auth-btn:not(:disabled):active { transform:translateY(0); }
      .auth-btn:disabled { cursor:not-allowed; }

      /* Bouton secondaire (créer un compte / se connecter) */
      .auth-secondary {
        width:100%; padding:14px; border-radius:13px; border:none; background:#eef2f7; color:#173b78;
        font-family:${F}; font-size:14px; font-weight:700; cursor:pointer;
        display:flex; align-items:center; justify-content:center; gap:8px; transition:background .15s;
      }
      .auth-secondary:hover { background:#e2e9f2; }

      /* Boutons sociaux */
      .auth-social {
        width:100%; padding:13px; border-radius:13px; border:1.5px solid #e8ecf2; background:#fff;
        font-family:${F}; font-size:14px; font-weight:600; color:#0f172a; cursor:pointer;
        display:flex; align-items:center; justify-content:center; gap:10px;
        transition:background .15s, border-color .15s, box-shadow .15s;
      }
      .auth-social:hover { background:#f8fafc; border-color:#d7dee8; box-shadow:0 2px 10px rgba(19,40,72,0.05); }
      .auth-social + .auth-social { margin-top:10px; }

      .auth-divider { display:flex; align-items:center; gap:12px; margin:20px 0 16px; }
      .auth-divider::before, .auth-divider::after { content:''; flex:1; height:1px; background:#e8ecf2; }
      .auth-divider span { font-size:12px; font-weight:600; color:#94a3b8; }

      .auth-back { display:inline-flex; align-items:center; gap:6px; background:none; border:none; cursor:pointer; color:#94a3b8; font-size:13px; font-family:${F}; padding:0; margin-bottom:20px; transition:color .15s; }
      .auth-back:hover { color:#475569; }

      .auth-foot { text-align:center; margin-top:16px; font-size:13px; color:#94a3b8; font-family:${F}; }
      .auth-foot-link { background:none; border:none; cursor:pointer; font-size:13px; color:#173b78; font-weight:700; font-family:${F}; padding:0; transition:color .15s; }
      .auth-foot-link:hover { color:#2a66b8; text-decoration:underline; text-underline-offset:3px; }

      .auth-terms { text-align:center; font-size:11.5px; color:#9aa6b5; line-height:1.6; margin-top:22px; }
      .auth-terms .lnk { color:#64748b; text-decoration:underline; text-underline-offset:2px; cursor:pointer; }

      .auth-caption { text-align:center; font-size:11px; color:#cbd5e1; margin-top:18px; }

      /* ── Mobile : style "app" centré (réf.) ── */
      @media (max-width: 900px) {
        .auth-brand { display:none; }
        .auth-form-wrap { padding:40px 22px 32px; align-items:flex-start; }
        .auth-mark {
          display:flex; align-items:center; justify-content:center;
          width:78px; height:78px; border-radius:21px; margin:8px auto 22px;
          background:#fff; border:1px solid #eef0f6; box-shadow:0 10px 30px rgba(19,40,72,0.14);
        }
        .auth-mark { box-shadow:0 12px 30px rgba(23,59,120,0.26); }
        .auth-mark img { width:62px; height:62px; object-fit:contain; }
        .auth-title, .auth-subtitle { text-align:center; }
        .auth-title { font-size:26px; }
      }
    `}</style>
  );
}

// ─── Spinner ───────────────────────────────────────────────────────────────────
export function Spinner({ size = 18, light = false }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      border: `2.5px solid ${light ? 'rgba(255,255,255,0.35)' : 'rgba(23,59,120,0.15)'}`,
      borderTopColor: light ? '#fff' : '#173b78',
      animation: 'auth-spin 0.7s linear infinite',
    }} />
  );
}

// ─── Style bouton primaire ─────────────────────────────────────────────────────
export function authBtnStyle(active) {
  return active
    ? { background: 'linear-gradient(135deg, #173b78 0%, #2a66b8 100%)', color: '#fff', boxShadow: '0 8px 24px rgba(23,59,120,0.3)' }
    : { background: '#e8edf5', color: '#9aa7bd', boxShadow: 'none' };
}

// ─── Boîte d'erreur ────────────────────────────────────────────────────────────
export function ErrorBox({ error }) {
  if (!error) return null;
  return <div className="auth-error"><span style={{ flexShrink: 0 }}>⚠</span> {error}</div>;
}

// ─── Boutons sociaux (Apple + Google) ──────────────────────────────────────────
export function SocialButtons({ onApple, onGoogle, prefix = 'Continuer avec' }) {
  return (
    <>
      <button type="button" className="auth-social" onClick={onApple}>
        <AppleIcon size={18} /> {prefix} Apple
      </button>
      <button type="button" className="auth-social" onClick={onGoogle}>
        <GoogleIcon size={18} /> {prefix} Google
      </button>
    </>
  );
}

// ─── Layout split-screen ───────────────────────────────────────────────────────
export default function AuthLayout({ children, footer }) {
  return (
    <>
      <AuthStyles />
      <div className="auth-shell">
        <aside className="auth-brand">
          <img className="brand-logo" src="/logo-white.png" alt="Wakaana Express"
            onError={e => { e.target.src = '/logo-transparent.png'; }} />
          <div className="brand-body">
            <div className="brand-eyebrow">Plateforme logistique</div>
            <h1 className="brand-head">La logistique de<br />votre e-commerce,<br /><span className="accent">simplifiée.</span></h1>
            <p className="brand-sub">
              Wakaana Express prend en charge votre stock, la confirmation de vos clients
              et la livraison — de bout en bout, partout au Sénégal.
            </p>
            <div className="brand-features">
              {BRAND_FEATURES.map(({ Icon, title, sub }, i) => (
                <div key={i} className="brand-feat">
                  <div className="brand-feat-ic"><Icon size={19} color="#93c5fd" strokeWidth={1.8} /></div>
                  <div>
                    <p className="brand-feat-t">{title}</p>
                    <p className="brand-feat-s">{sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="brand-foot">
            <div><div className="brand-stat-v">2 500 F</div><div className="brand-stat-l">par livraison</div></div>
            <div><div className="brand-stat-v">Suivi GPS</div><div className="brand-stat-l">en temps réel</div></div>
            <div><div className="brand-stat-v">7j/7</div><div className="brand-stat-l">disponible</div></div>
          </div>
        </aside>

        <main className="auth-main">
          <div className="auth-form-wrap">
            <div className="auth-form-inner">
              <div className="auth-mark">
                <img src="/logo512.png" alt="Wakaana Express"
                  onError={e => { e.target.src = '/logo192.png'; }} />
              </div>
              {children}
              <p className="auth-caption">{footer || 'Wakaana Express · Plateforme logistique'}</p>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
